import env from '../../utils/env'
import Axios from 'axios'
import GetToken from './GetToken'
import Appointments from './Appointments'

class CFOAuthApi {
  public readonly getToken: ReturnType<typeof GetToken>
  public readonly appointments: ReturnType<typeof Appointments>
  constructor() {
    const axiosInstanceUrlencoded = Axios.create({
      baseURL: env.CFOAuthApiUrl,
      responseType: 'json',
      headers: {
        scope: env.CFOAuthClientScope,
        client_secret: env.CFOAuthClientSecret,
        client_id: env.CFOAuthClientSecret,
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    })
    const axiosInstanceZinier = Axios.create({
      baseURL: `${env.ZinierApiUrl}`,
      responseType: 'json',
      headers: {
        'Content-Type': 'application/json',
      },
    })
    axiosInstanceZinier.interceptors.request.use(
      async (config) => {
        // Function to get token with retry logic
        const getTokenWithRetry = async (retries = 5, delay = 500): Promise<string | null> => {
          let token = sessionStorage && sessionStorage.getItem('access_token')
          
          // If token exists, return it immediately
          if (token) return token
          
          // If no token and we have retries left, wait and try again
          if (retries > 0) {
            console.log(`Token not found in CFOAuth, retrying... (${retries} retries left)`)
            await new Promise<void>(resolve => setTimeout(resolve, delay))
            return getTokenWithRetry(retries - 1, delay)
          }
          
          // If we've exhausted retries, return null
          console.warn('Failed to get auth token in CFOAuth after multiple retries')
          return null
        }
        
        // Try to get token with retry logic
        const token = await getTokenWithRetry()
        
        if (token) {
          config.headers.authorization = `Bearer ${token}`
        }

        return config
      },
      (error) => Promise.reject(error),
    )
    this.getToken = GetToken(axiosInstanceUrlencoded)
    this.appointments = Appointments(axiosInstanceZinier)
  }
}

export default function createCFOApiClient(): CFOAuthApi {
  return new CFOAuthApi()
}
